/* eslint-disable no-unused-vars */
import { Typography } from "@mui/material";
import PSettingsCard from "../../components/pos/PSettingsCard.jsx";
import PText from "../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function DeliItemSettings(props) {
  const { t } = useTranslation();
  const translate = t;
  const [liveValidation, setLiveValidation] = useState(false);

  const [deptCodelen, setDeptCodelen] = useState("0");
  const [deptCodelenError, setDeptCodelenError] = useState();
  const [itemCodelen, setItemCodelen] = useState("0");
  const [itemCodelenError, setItemCodelenError] = useState();
  const [valueLength, setValueLength] = useState("0");
  const [valueLengthError, setValueLengthError] = useState();
  const [parityLength, setParityLength] = useState("0");
  const [parityLengthError, setParityLengthError] = useState();
  useEffect(() => {
    if (liveValidation) validateItemCodeLen();
  }, [itemCodelen]);

  const content = (
    <table width="100%">
      <tbody>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Dept Code Length")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"number"}
              value={deptCodelen}
              error={deptCodelenError}
              onChange={(e) => setDeptCodelen(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Item Code Length")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"number"}
              value={itemCodelen}
              error={itemCodelenError}
              onChange={(e) => setItemCodelen(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">{translate("Value Length")}</Typography>
          </td>
          <td width={200}>
            <PText
              type={"number"}
              value={valueLength}
              error={valueLengthError}
              onChange={(e) => setValueLength(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Parity Length")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"number"}
              value={parityLength}
              error={parityLengthError}
              onChange={(e) => setParityLength(e.target.value)}
            ></PText>
          </td>
        </tr>
      </tbody>
    </table>
  );

  function validate() {
    setLiveValidation(true);
    return validateItemCodeLen();
  }

  function validateItemCodeLen() {
    if (itemCodelen) {
      let val = parseInt(itemCodelen);
      if (val < 1) {
        setItemCodelenError(
          translate("Item Code Length Should be Greater than Zero")
        );
        return false;
      } else if (val > 6) {
        setItemCodelenError(
          translate("Item Code Length Should be Less than Ten")
        );
        return false;
      } else {
        setItemCodelenError("");
      }
    } else {
      setItemCodelenError(translate("Item Code Length is required"));
      return false;
    }

    if (deptCodelen) {
      let val = parseInt(deptCodelen);
      if (val < 1) {
        setDeptCodelenError(
          translate("Dept Code Length Should be Greater than Zero")
        );
        return false;
      } else if (val > 6) {
        setDeptCodelenError(
          translate("Dept Code Length Should be Less than 3")
        );
        return false;
      } else {
        setDeptCodelenError("");
      }
    } else {
      setDeptCodelenError(translate("Dept Code Length is required"));
      return false;
    }

    if (valueLength) {
      let val = parseInt(valueLength);
      if (val < 1) {
        setValueLengthError(
          translate("Value Length Should be Greater than Zero")
        );
        return false;
      } else if (val > 10) {
        setValueLengthError(translate("Value Length Should be Less than Ten"));
        return false;
      } else {
        setValueLengthError("");
      }
    } else {
      setValueLengthError(translate("Value Length is required"));
      return false;
    }

    if (parityLength) {
      let val = parseInt(parityLength);
      if (val < 1) {
        setParityLengthError(
          translate("Parity Length Should be Greater than Zero")
        );
        return false;
      } else if (val > 2) {
        setParityLengthError(translate("Parity Length Should be Less than 2"));
        return false;
      } else {
        setParityLengthError("");
      }
    } else {
      setValueLengthError(translate("Parity Length is required"));
      return false;
    }
    return true;
  }

  function createPayload(payload) {
    payload["deptCodelen"] = deptCodelen;
    payload["itemCodelen"] = itemCodelen;
    payload["valueLength"] = valueLength;
    payload["parityLength"] = parityLength;
    console.log(payload);
  }

  function populateObject(bean) {
    console.log("POPULATE");
    setDeptCodelen(bean.deptCodelen);
    setItemCodelen(bean.itemCodelen);
    setValueLength(bean.valueLength);
    setParityLength(bean.parityLength);
  }

  return (
    <PSettingsCard
      avatar="D"
      title={translate("Deli Item Settings")}
      cardContent={content}
      onValidate={validate}
      createPayload={createPayload}
      populateObject={populateObject}
      messagHandler={props.messagHandler}
      settingKey="deli"
    ></PSettingsCard>
  );
}
